import { FighterTile } from '../../../components/FighterTile';

interface Winner {
  place: number;
  name: string;
  imageUrl: string;
}

const WINNERS: Winner[] = [
  {
    place: 1,
    name: 'Luke',
    imageUrl: '/characters/kirby-01.webp',
  },
  {
    place: 2,
    name: 'Hailey',
    imageUrl: '/characters/cloud-00.webp',
  },
  {
    place: 3,
    name: 'Alea',
    imageUrl: '/characters/kirby-02.webp',
  },
  {
    place: 4,
    name: 'David',
    imageUrl: '/characters/mr-game-and-watch-05.webp',
  },
  {
    place: 5,
    name: 'Lucas',
    imageUrl: '/characters/pikachu-01.webp',
  },
];

/**
 * Winners podium: celebratory landing page after the party.
 * Luke is displayed top-center and larger; the other four runners-up below.
 */
export function WinnersStep() {
  const luke = WINNERS[0];
  const runners = WINNERS.slice(1);

  return (
    <div className="smash-title-screen">
      {/* Banner section — celebratory headline */}
      <div className="smash-title-banner">
        <div className="smash-title-banner__white smash-winners-banner-white">
          <h1 className="smash-title-banner__headline" aria-label="That's a wrap! Luke is 10 — and undefeated.">
            <svg
              className="smash-title-banner__arc"
              viewBox="0 0 1000 220"
              preserveAspectRatio="xMidYMid meet"
              aria-hidden="true"
            >
              <defs>
                <path id="winners-title-arc" d="M 20 190 Q 500 150 980 190" fill="none" />
              </defs>
              <text>
                <textPath href="#winners-title-arc" startOffset="50%" textAnchor="middle">
                  That's a wrap!
                </textPath>
              </text>
            </svg>
          </h1>
          <p className="smash-winners-thanks">Thanks for coming!</p>
        </div>
        <div className="smash-title-banner__red">
          <p className="smash-title-banner__prompt">Luke is 10 — and undefeated.</p>
        </div>
      </div>

      {/* Winners podium content */}
      <div className="smash-winners-container">
        {/* Luke: #1, top-center, larger */}
        <div className="smash-winners-top">
          <div className="smash-winners-badge">👑</div>
          <div className="smash-winners-luke-wrapper">
            <FighterTile
              imageUrl={luke.imageUrl}
              label={luke.name}
            />
          </div>
          <div className="smash-winners-place">#1</div>
        </div>

        {/* Runners-up: 4 tiles below in a row */}
        <div className="smash-winners-runners">
          {runners.map((winner) => (
            <div key={winner.place} className="smash-winners-runner-item">
              <div className="smash-winners-runner-place">#{winner.place}</div>
              <FighterTile
                imageUrl={winner.imageUrl}
                label={winner.name}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
